import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const records: SxStyle = {
  p: 2.5,
  background: (p) => p.palette.common.white,
};

export const totals: SxStyle = {
  px: 2,
  py: 1,
  pb: 2,
  background: (p) => p.palette.primary[25],
  borderTopColor: (p) => p.palette.primary[100],
  borderTopWidth: '1px',
  borderTopStyle: 'dashed',
};
